import countryNames from 'react-phone-number-input/locale/en';

const countryCodesByName = {};
Object.keys(countryNames).forEach((k) => (countryCodesByName[countryNames[k].toLowerCase()] = k));

const general = {
  adminReminderNum: 4,
  country_code_by_name: countryCodesByName,
  limit_options: [10, 20, 50, 100],
  gender: [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'other', label: 'Other' }
  ],
  appointment_times: [
    { value: '10', label: '10 AM' },
    { value: '14', label: '2 PM' },
    { value: '16', label: '4 PM' }
  ],
  analyse_type: [
    { value: 'test', label: 'Test' },
    { value: 'reports', label: 'Reports' },
    { value: 'x-ray', label: 'X-ray' }
  ],
  medicine_period: [
    { value: 'before_meal', label: 'Before Meal' },
    { value: 'after_meal', label: 'After Meal' },
    { value: 'any', label: 'Any' }
  ],
  time_unit: [
    { value: 'days', label: 'days' },
    { value: 'weeks', label: 'Weeks' },
    { value: 'months', label: 'Months' }
  ],
  medicine_times: [
    { value: 'morning', label: 'Morning' },
    { value: 'lunch', label: 'Lunch' },
    { value: 'dinner', label: 'Dinner' }
  ],
  health_statuses: [
    { value: 'in_process', label: 'In Process' },
    { value: 'completed', label: 'Completed' }
  ],
  doctor_types: [
    { value: 'resident_doctor', label: 'Resident Doctor' },
    { value: 'specialist_doctor', label: 'Specialist Doctor' },
    { value: 'primary_doctor', label: 'Primary Doctor' },
    { value: 'general_practitioner', label: 'General Practitioner' },
    { value: 'nutritionist', label: 'Nutritionist' },
    { value: 'fitness_trainer', label: 'Fitness trainer' },
    { value: 'psychologist', label: 'Psychologist' }
  ],
  specialist: [
    { value: 'internal-medicine', label: 'Internal medicine' },
    { value: 'dermatovenerology', label: 'Dermatovenerology' },
    {
      value: 'obstetrics-gynaecology',
      label: 'Obstetrics & Gynaecology'
    },
    { value: 'urology', label: 'Urology' },
    { value: 'pediatrics', label: 'Pediatrics' },
    { value: 'neonatology', label: 'Neonatology' },
    { value: 'gastroenterology', label: 'Gastroenterology' },
    {
      value: 'pediatric-gastroenterology',
      label: 'Pediatric Gastroenterology'
    },
    { value: 'cardiology', label: 'Cardiology' },
    { value: 'pediatric-cardiology', label: 'Pediatric Cardiology' },
    { value: 'otolaryngology-ent', label: 'Otolaryngology (ENT)' },
    { value: 'hematology', label: 'Hematology' },
    { value: 'laboratory-medicine', label: 'Laboratory medicine' },
    { value: 'pulmonology', label: 'Pulmonology' },
    { value: 'pediatric-pulmonology', label: 'Pediatric Pulmonology' },
    { value: 'nephrology', label: 'Nephrology' },
    { value: 'pediatric-nephrology', label: 'Pediatric Nephrology' },
    { value: 'neurology', label: 'Neurology' },
    { value: 'pediatric-neurology', label: 'Pediatric Neurology' },
    { value: 'neurosurgery', label: 'Neurosurgery' },
    { value: 'radiotherapy', label: 'Radiotherapy' },
    {
      value: 'radiology-and-medical-imaging',
      label: 'Radiology and medical imaging'
    },
    { value: 'oncology', label: 'Oncology' },
    {
      value: 'pediatric-oncology-and-hematology',
      label: 'Pediatric oncology and hematology'
    },
    {
      value: 'orthopedics-and-traumatology',
      label: 'Orthopedics and Traumatology'
    },
    { value: 'pediatric-orthopedics', label: 'Pediatric orthopedics' },
    { value: 'medical-recovery', label: 'Medical recovery' },
    { value: 'infectious-diseases', label: 'Infectious diseases' },
    { value: 'endocrinology', label: 'Endocrinology' },
    {
      value: 'allergology-and-clinical-immunology',
      label: 'Allergology and Clinical Immunology'
    },
    {
      value: 'diabetes-nutrition-and-metabolic-diseases',
      label: 'Diabetes, Nutrition and Metabolic Diseases'
    },
    { value: 'general-surgery', label: 'General Surgery' },
    { value: 'vascular-surgery', label: 'Vascular Surgery' },
    { value: 'cardiovascular-surgery', label: 'Cardiovascular Surgery' },
    {
      value: 'plastic-surgery-reconstructive-microsurgery',
      label: 'Plastic surgery - reconstructive microsurgery'
    },
    { value: 'pediatric-surgery', label: 'Pediatric surgery' },
    { value: 'thoracic-surgery', label: 'Thoracic surgery' },
    { value: 'ophthalmology', label: 'Ophthalmology' },
    { value: 'rheumatology', label: 'Rheumatology' },
    { value: 'family-medicine', label: 'Family medicine' },
    { value: 'general-medicine', label: 'General medicine' },
    {
      value: 'anesthesia-and-intensive-care',
      label: 'Anesthesia and intensive care'
    },
    { value: 'psychiatry', label: 'Psychiatry' },
    { value: 'pediatric-psychiatry', label: 'Pediatric psychiatry' },
    { value: 'psychology', label: 'Psychology' },
    { value: 'pathological-anatomy', label: 'Pathological anatomy' },
    {
      value: 'oral-and-maxillofacial-surgery',
      label: 'Oral and maxillofacial surgery'
    },
    { value: 'orthodontics', label: 'Orthodontics' },
    { value: 'dentistry', label: 'Dentistry' },
    { value: 'medical-genetics', label: 'Medical genetics' },
    {
      value: 'geriatrics-and-gerontology',
      label: 'Geriatrics and gerontology'
    },
    { value: 'medical-expertise', label: 'Medical expertise' },
    { value: 'sports-medicine', label: 'Sports medicine' },
    { value: 'emergency-medicine', label: 'Emergency medicine' }
  ],
  blood_groups: [
    { value: 'a', label: 'A' },
    { value: 'b', label: 'B' },
    { value: 'ab', label: 'AB' },
    { value: 'o', label: 'O' }
  ],
  rhesus_factors: [
    { value: 'pozitiv', label: 'Pozitiv' },
    { value: 'negativ', label: 'Negativ' }
  ],
  appointment_types: [
    { value: 'virtual', label: 'Virtual' },
    { value: 'in_office', label: 'In office' }
  ],
  slot_types: [
    { value: 'free_slot', label: 'Free Slot' },
    { value: 'patient', label: 'Patient' }
  ],
  manager_access: [
    {
      label: 'Appointments',
      value: 'appointments'
    },
    {
      label: 'Treatments',
      value: 'treatments'
    },
    {
      label: 'Doctors',
      value: 'doctors'
    },
    {
      label: 'Customer Support',
      value: 'customerSupport'
    }
  ],
  managerAccess: {
    owner: 'owner',
    admin: 'admin',
    doctors: 'doctors',
    treatments: 'treatments',
    appointments: 'appointments'
  },
  userStatus: {
    pending: 'pending', // doctor/clinic can login but can not do all functions
    approved: 'approved', // doctor/clinic can login but can not do all functions
    enabled: 'enabled', // doctor/clinic can login and do all functions
    disabled: 'disabled', // can not login
    declined: 'declined', // doctor/clinic can login and do all functions, but send email to ask more info to approve
    updated: 'updated', // doctor/clinic updated more info after declined
    inactive: 'inactive', // temporary account for invitation
    active: 'active' // status for patient
  },
  appointmentStatus: {
    upcoming: 'upcoming',
    cancelled: 'cancelled',
    attended: 'attended',
    not_attended: 'not_attended'
  },
  invoiceStatus: {
    unpaid: 'unpaid',
    paid: 'paid',
    refund: 'refund'
  },
  defaultCurrency: 'USD',
  accountStates: {
    available: 'available',
    not_available: 'not_available'
  },
  currencyOptions: [
    { value: 'USD', label: 'USD' },
    { value: 'EUR', label: 'EUR' },
    { value: 'RON', label: `RON` }
  ]
};

export default general;
